import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { environment } from '../../environments/environment';
import { Equipe } from './models/equipe';
import { TeamsService } from './teams.service';
import { LoaderService } from '../loader/loader.service';
import * as moment from 'moment';
import { FormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { startWith, map, takeUntil } from 'rxjs/operators';
import { PermissionsService } from '../services/permissions.service';

declare var $;

@Component({
  selector: 'app-teams',
  templateUrl: './teams.component.html',
  styleUrls: ['./teams.component.scss'],
})
export class TeamsComponent implements OnInit, OnDestroy {
  env;
  teams: Equipe[] = [];
  page = 1;
  pageSize = 10;
  collectionSize = 0;

  teams$: Observable<Equipe[]>;
  filter = new FormControl('');

  private unsubscribe$ = new Subject();

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private teamsService: TeamsService,
    private loaderService: LoaderService,
    public permissionsService: PermissionsService
  ) {
    this.env = environment;
  }

  ngOnInit() {
    this.route.params.pipe(takeUntil(this.unsubscribe$)).subscribe(params => {
      if (this.permissionsService.isPermitted('teams')) {
        this.getTeams();
      } else {
        this.router.navigateByUrl(`/dash/${params.cnpj}`);
      }
    });
  }

  async getTeams() {
    const loader = await this.loaderService.notifica({
      title: 'Buscando equipes...',
      date: moment().toISOString(),
      type: 'loading',
    });

    this.teams = await this.teamsService.getTeams().toPromise();

    this.teams$ = this.filter.valueChanges.pipe(
      startWith(''),
      map(text => this.search(text))
    );

    loader.dismiss();
  }

  search(text: string): Equipe[] {
    const teamsFiltered: Equipe[] = this.teams.filter(team => {
      const term = text.toLowerCase();
      return (
        team.nome.toLowerCase().includes(term) ||
        team.supervisor.nome.toLowerCase().includes(term) ||
        team.gestor.nome.toLowerCase().includes(term)
      );
    });

    this.page = 1;
    this.collectionSize = teamsFiltered.length;

    return teamsFiltered;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
